import { render, staticRenderFns } from "./segmentedShowroomOrders.vue?vue&type=template&id=38f3bbfe&"
import script from "./segmentedShowroomOrders.vue?vue&type=script&lang=js&"
export * from "./segmentedShowroomOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports